import React, { useState, useEffect } from "react";

import { toast } from "react-toastify";

import * as IconsSVG from "../../../../assets/iconsSVG";
import images from "../../../../constants/images";

import MaterialUI from "../../../../material-UI";
import axiosLead from "../../../../services/lead";
// import warn from "../../../../constants/toast";
import handleApiError from "../../../../utils/handleApiError";

import * as Styles from "../../styles";

interface Props {
  leads: [
    {
      idLead?: string;
      idLeadCorretor: string;
    }
  ];
  onClose: Function;
  open: boolean;
  hotRefreshFunc: Function;
  transferirTodasPaginas?: boolean;
  idCorretorOrigem?: string;
}

const TransferForm: React.FC<Props> = ({
  leads,
  onClose,
  open,
  hotRefreshFunc,
  transferirTodasPaginas,
  idCorretorOrigem,
}) => {
  const [corretores, setCorretores] = useState([]);
  const [value, setValue] = useState({
    idUsuario: "",
    nome: "",
    idCorretor: "",
  });
  const [loading, setLoading] = useState<boolean>(false);
  const [transferCommentCount, setTransferCommentCount] = useState<number>(0);
  const [motivo, setMotivo] = useState<string>("");
  const [isConcluded, setIsConcluded] = useState<boolean>(false);

  useEffect(() => {
    requestCorretores();
  }, []);

  const requestCorretores = async () => {
    try {
      const response = await axiosLead.GetCorretores();
      setCorretores(response.data.data);
    } catch (error: any) {
      handleApiError(error);
    }
  };

  const handleTransferComment = (comment: string) => {
    setMotivo(comment);
    setTransferCommentCount(comment?.length);
  };

  const transfLead = async () => {
    try {
      if (value.nome === "") {
        toast.error("Selecione um corretor.");
        return;
      }
      setLoading(true);
      await axiosLead.transfLead({
        ...(transferirTodasPaginas ? { idCorretorOrigem } : { leads }),
        idCorretorDestino: value.idCorretor,
        descricaoMotivoTransferencia: motivo,
        transferirTodasPaginas: !!transferirTodasPaginas,
      });
      toast.success("Leads transferidos com sucesso.");
      setIsConcluded(!isConcluded);
    } catch (error: any) {
      handleApiError(error);
    }
    setLoading(false);
  };

  return (
    <>
      <Styles.MultipleTransferComponent>
        <Styles.Autocomplete
          id="combo-box-demo"
          options={corretores}
          renderInput={(params: any) => (
            <>
              <Styles.LabelText>Corretor de destino</Styles.LabelText>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Corretor de destino"
              />
            </>
          )}
          getOptionLabel={(option: any) => option.nome || ""}
          onChange={(event, newValue: any) => {
            setValue(newValue);
          }}
        />
        <Styles.MultLineField>
          <Styles.LabelText>Motivo</Styles.LabelText>
          <Styles.TextField
            onChange={(e: any) => handleTransferComment(e.target.value)}
            label="Multiline"
            variant="outlined"
            fullWidth
            multiline
            minRows={3}
            rows={3}
            defaultValue="Default Value"
            value={motivo}
            inputProps={{ maxLength: 500 }}
          />
          <Styles.CountText>{transferCommentCount}/500</Styles.CountText>
        </Styles.MultLineField>
      </Styles.MultipleTransferComponent>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Styles.Button
            className="transfer-btn"
            color="secondary"
            variant="contained"
            onClick={transfLead}
          >
            {loading ? <MaterialUI.CircularProgress /> : "Transferir"}
          </Styles.Button>
        </Styles.FooterDialog>
      </Styles.Footer>
      {isConcluded && (
        <Styles.ContainerConfirm>
          <Styles.HeaderContent>
            <Styles.BoxImgSuccess>
              <IconsSVG.SuccessIcon />
            </Styles.BoxImgSuccess>
            <Styles.HeaderTitle>Leads transferidos</Styles.HeaderTitle>
          </Styles.HeaderContent>
          <Styles.InfoContent>
            <Styles.TitleInfo>
              Estes leads não serão mais exibidos na sua carteira
            </Styles.TitleInfo>
            <Styles.BoxImgArt>
              <img src={images.transferSuccessArt} alt="Art Success" />
            </Styles.BoxImgArt>
            <Styles.LinkReturn
              onClick={() => {
                hotRefreshFunc();
                onClose(!open);
                setIsConcluded(!isConcluded);
              }}
            >
              Voltar para a carteira
            </Styles.LinkReturn>
          </Styles.InfoContent>
        </Styles.ContainerConfirm>
      )}
    </>
  );
};

export default TransferForm;
